import { connect } from 'react-redux';

import { AdFoxBannerTracker } from './tracker';
import { IAppState } from '../../../../common/state';
import { prepareTrackingData } from '../../../../utils/prepareTrackingData';
import { IWithTrackingProps } from '../../../hoc/withTracking';

export function mapStateToProps(state: IAppState): IWithTrackingProps {
  const { filters, results, user, breadcrumbs } = state;

  return {
    tracking: prepareTrackingData(filters, results, breadcrumbs, user),
  };
}

export const AdFoxBannerTrackerContainer = connect<IWithTrackingProps>(mapStateToProps)(AdFoxBannerTracker);
